// Ждёт, пока элемент перестанет ездить по вертикали: пока выше него
// догружаются картинки, его позиция меняется, и прокрутка к нему промахивается.
export const checkForNoYAxisOffset = (
  element: HTMLElement,
  timeIntervalForChecking: number = 100,
  maxWaitTime: number = 3000
): Promise<void | Error> => {
  return new Promise((resolve, reject): void => {
    let intervalId: number | null = null
    let lastKnownPosition: number | null = element.getBoundingClientRect().top
    let waited = 0

    const stop = (): void => {
      if (intervalId !== null) {
        clearInterval(intervalId)
        intervalId = null
      }
    }

    const checkPosition = (): void => {
      waited += timeIntervalForChecking
      const currentPosition: number = element.getBoundingClientRect().top

      // Страховка от бесконечного ожидания: если что-то на странице дёргается
      // постоянно (анимация, скелетон), прокручиваем по последнему замеру.
      if (currentPosition === lastKnownPosition || waited >= maxWaitTime) {
        stop()
        resolve()
      } else {
        lastKnownPosition = currentPosition
      }
    }

    try {
      intervalId = window.setInterval(checkPosition, timeIntervalForChecking)
    } catch (error) {
      stop()
      reject(error)
    }
  })
}
